import { render } from "./Character.vue?vue&type=template&id=65cf6ce8"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__